import { graphql } from "gql";

const PRESIGNED_URL_QUERY = graphql(`
  query PresignedUrl($key: String!) {
    presignedUrl(key: $key)
  }
`);

export default PRESIGNED_URL_QUERY;
